import { SEND_MESSAGE_BACK, default as sendMessageBack } from 'botframework-webchat-core/lib/actions/sendMessageBack';
import { SEND_POST_BACK } from 'botframework-webchat-core/lib/actions/sendPostBack';
const messageBackTranscriptMiddleware = ({ dispatch }) => (next) => (action) => {
    var _a, _b;
    if (action.type === SEND_MESSAGE_BACK) {
        action.payload.text = (_a = action.payload.text) !== null && _a !== void 0 ? _a : action.payload.displayText;
    }
    else if (action.type === SEND_POST_BACK && ((_b = action.payload) === null || _b === void 0 ? void 0 : _b.value)) {
        const data = action.payload.value;
        switch (data.type) {
            case 'linkedAnswer':
            case 'answerDisambiguationSuccess': {
                dispatch(sendMessageBack(action.payload.value, data.title, data.title));
                return;
            }
        }
    }
    return next(action);
};
export { messageBackTranscriptMiddleware };
//# sourceMappingURL=messageBackTranscriptMiddleware.js.map